export default __webpack_public_path__ + "static/media/what_is_clio_images.2087afbc.png";